import React from 'react'
import { InputSwitch } from 'primereact/inputswitch';
import { Button } from 'primereact/button';

function ChatHeader({
    isEnabled,
    handleToggleChange,
    showSimulator,
    setShowSimulator,
    saveChatJourney,
    isMobile
}) {
    return (
        <div className="chat-journey-header">
            {
                showSimulator ? (
                    <>
                        <Button
                            icon="pi pi-arrow-left"
                            className="p-button-text"
                            onClick={() => setShowSimulator(false)}
                            label={!isMobile && "Back to Builder"}
                        />
                        <Button
                            icon="pi pi-save"
                            className="p-button-primary"
                            onClick={() => saveChatJourney(false)}
                            label={"Publish Journey"}
                        />
                    </>

                ) : (
                    <>
                        <div className="toggle-content">
                            <span className="toggle-label">Chat Journey</span>
                            <InputSwitch
                                checked={isEnabled}
                                onChange={(e) => handleToggleChange(e)}
                            />
                        </div>
                        <Button
                            icon="pi pi-play"
                            className="p-button-primary"
                            onClick={() => setShowSimulator(true)}
                            label={"Test Chat"}
                        />
                    </>
                )
            }
        </div>
    )
}

export default ChatHeader
